.navItemContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
}

.navItemContainerCollapsed {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  /* padding: 0.5rem 0; */
  position: relative;
}

.navItem {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.5rem;
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  border-radius: 8px;
  color: var(--static-text-strong);
}

.navItem:hover {
  background-color: var(--sentiment-background-neutral);
}

/* Active navItem and navItem with active children should have same hover color */
.navItem.active:hover {
  background-color: var(--selectable-selected);
}

.navItem:has(.logoActive):hover {
  background-color: var(--selectable-selected);
}

/* Logo button in collapsed mode */
.logoButton {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  border: none;
  background-color: transparent;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.2s ease;
  position: relative;
  color: var(--static-text-strong);
  margin-bottom: 0.25rem;
}

.logoButton:hover {
  background-color: var(--sentiment-background-neutral);
}

/* Change hover color for active logoButton */
.logoButton.active:hover {
  background-color: var(--selectable-selected);
}

.logoButton:has(.logoActive):hover {
  background-color: var(--selectable-selected);
}

/* Active states */
.active {
  background-color: var(--selectable-selected);
  border-radius: 8px;
}

.childActive {
  background-color: var(--selectable-selected) !important;
  border-radius: 8px;
  font-weight: 600;
  color: var(--static-text-strong) !important;
}

.open {
  background-color: var(--selectable-selected);
  border-radius: 8px;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  flex-shrink: 0;
}

.logoActive {
  color: var(--primary-active);
}

.logoCollapsed {
  display: flex;
  align-items: center;
  justify-content: center;
}

.label {
  flex: 1;
  font-size: var(--fs-normal, 1rem);
  font-weight: 500;
}

.labelCollapsed {
  font-size: var(--fs-x-small);
  text-align: center;
  color: var(--static-text-strong);
}

.arrow {
  display: flex;
  align-items: center;
  margin-left: auto;
  transition: transform 0.2s ease;
}

.arrowUp {
  transform: rotate(180deg);
}

.dropdown {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.5rem;
  padding-left: 16%;
  padding-top: 0.5rem;
  /* padding-bottom: 0.5rem; */
}

.dropdownItem {
  display: flex;
  align-items: center;
  width: 100%;
  /* padding: 0.75rem 1rem 0.75rem 2rem; */
  padding: 0.25rem 0.5rem;
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: background-color 0.2s ease;
  text-align: left;
  color: var(--static-text-standard);
  border-radius: 8px;
  font-size: var(--fs-small);
}

.dropdownItem:not(:disabled):hover {
  background-color: var(--sentiment-background-neutral);
}

.dropdownItem.childActive {
  background-color: var(--selectable-selected);
  border-radius: 8px;
  font-weight: 600;
  color: var(--static-text-strong);
}

.dropdownItem.active {
  background-color: var(--selectable-selected);
  border-radius: 8px;
}

/* Change hover color for active dropdownItem */
.dropdownItem.childActive:hover,
.dropdownItem.active:hover {
  background-color: var(--selectable-selected);
}

/* Tooltip content styles */
.tooltipContent {
  background-color: var(--static-background-strong, white);
  border-radius: 8px;
  min-width: 120px;
  overflow: hidden;
}

.tooltipItem {
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
  color: var(--static-text-standard);
  border-radius: 8px;
}

.tooltipItem:hover {
  background-color: var(--sentiment-background-neutral);
}

.tooltipItem.active {
  background-color: var(--selectable-selected);
  border-radius: 8px;
}

/* Change hover color for active tooltipItem */
.tooltipItem.active:hover {
  background-color: var(--selectable-selected);
}